import { TargetingCountries } from "src/entities/targetingCountries";
export const TargetingCountriesPage = () => {
  return <TargetingCountries />;
};
